export default __webpack_public_path__ + "static/lu-42680afadc7b3fbeba831220b061265d.svg";